import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { of, Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AddressBookService } from 'src/app/components/address-book/address-book.service';
import { AppConstant } from 'src/app/shared/constants/app.constant';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Helper } from 'src/app/shared/utils/helper';
import { SearchInputComponent } from '../search-input/search-input.component';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { StaticText } from '../../constants/static-text';
import { take, tap } from 'rxjs/operators';
import { SortVM } from '../up-down-sort/up-down-sort.component';
import { SortDirection } from '../../enums/SortDirection.enum';
import { AddressBookModalHeader } from './addressbook-header-modal';

@Component({
  selector: 'app-address-book-modal',
  templateUrl: './address-book-modal.component.html',
  styleUrls: ['./address-book-modal.component.css']
})
export class AddressBookModalComponent implements OnInit, OnDestroy {
  tableHeader = AddressBookModalHeader;
  @ViewChild('searchInput', { static: true }) searchInput: SearchInputComponent;
  public onClose: Subject<any>;
  sortBy$ = new Subject();
  initialResult = of({
    items: [],
    pageSize: 10,
    totalCount: 0
  });
  initialFilter = {
    Sort: null,
    SortDirection: null,
    Page: 1,
    Query: '',
    wx: window.screenX,
    wy: window.screenY
  }
  subs: Subscription;
  readonly uiState: string = "address-book-lookup.address-book.list";

  readonly isEmpty = Helper.isEmpty;
  readonly PAGE_SIZE = AppConstant.PAGE_SIZE;
  readonly MAX_PAGE_NUMBERS = AppConstant.MAX_PAGE_NUMBERS;

  constructor(
    public bsModalRef:BsModalRef,
    private addressBookService: AddressBookService,
    private msService: MessageService,
  ) { }

  ngOnInit() {
    this.onClose = new Subject();
    this.loadState();
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  onApply() {
    this.loadState();
  }
  onReset() {
    this.clearState();
    this.loadState();
  }

  load(){
    this.addressBookService.listAddressBook(this.initialFilter).pipe(
      take(1),
      tap((res:any)=>this.initialResult=of(res.result))
    ).subscribe();
  }


  pageChanged({ page }){
    this.initialFilter.Page = page;
    this.load();
  }


  onClickHeader(e) {
    this.sortBy$.next(e);
  }

  onChangeSort(e: SortVM) {
    const direction = e.isAsc ? SortDirection.ASC : SortDirection.DESC;
    this.initialFilter.Sort = e.id;
    this.initialFilter.SortDirection = direction;
    this.loadState();
  }



  onSearch(term) {
    this.initialFilter.Query = term;
    this.loadState();
  }

  onSearchKeyup(term) {
    this.initialFilter.Query = term;
  }

  setState() {
    this.msService.send(this.uiState, this.initialFilter);
  }

  getState() {
    this.subs = this.msService.get().pipe(
      tap((res) => {
        if (this.uiState == res.name) {
          this.initialFilter = { ...res.data };
        }
      }),
    ).subscribe();
    this.searchInput.search = this.initialFilter.Query;
  }

  loadState() {
    this.getState();
    this.load();
  }

  clearState() {
    this.msService.clear();
    this.initialFilter = {
      Sort: null,
      SortDirection: null,
      Page: 1,
      Query: '',
      wx: window.screenX,
      wy: window.screenY
    }
    this.subs.unsubscribe();
  }

  onConfirm(data){
    this.onClose.next({data:data, success:true});
    this.bsModalRef.hide();
  }
}
